import { render, staticRenderFns } from "./VenueLegal.vue?vue&type=template&id=96f0ead4"
import script from "./VenueLegal.vue?vue&type=script&lang=ts"
export * from "./VenueLegal.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports